import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { CurrentService } from '@services/current.service';
import { CurrentRights } from '@models/current.model';
import { RightValueType } from '@models/enums';
import { filter, map } from 'rxjs';

export const guardCreate =
    (role: keyof CurrentRights): CanActivateFn =>
    (route: ActivatedRouteSnapshot) => {
        const router = inject(Router);
        const rights$ = inject(CurrentService).rights$;

        return rights$.pipe(
            filter(Boolean),
            map((rights) => {
                if (!rights) {
                    return new RedirectCommand(router.parseUrl('/access-denied'), {
                        skipLocationChange: true,
                    });
                }
                const value = rights![role];

                const id = route.paramMap.get('id');

                if (value === RightValueType.NotAllowed && id === 'create') {
                    return new RedirectCommand(router.parseUrl('/access-denied'), {
                        skipLocationChange: true,
                    });
                } else {
                    return true;
                }
            }),
        );
    };
